<template>
  <b-row>
    <div class="col-lg-12 col-md-12 mt-2">
      <CentroCustosFilter 
        :filters="filters"
        :loading="loading"
        :exportar-disabled="exportarDisabled"
        @pesquisar="pesquisarCentrosCustos"
        @limpar="limparFiltros"
        @exportar="exportarRelatorio"
      />
      <div v-if="loading" class="loading" />
      <CentrosCustosTable 
        v-else
        :centrosCustosResponse="centrosCustosResponse"
        :filters="filters"
        @modelAlterado="alterarPaginacao"
      />
    </div>
  </b-row>
</template>

<script>
import CentrosCustosTable from "./widgets/tables/CentrosCustosTable";
import CentroCustosFilter from "./CentroCustosFilter.vue";

// Mixins
import { filtrosMixin, buscaDadosMixin, exportacaoMixin } from "./mixins";

export default {
  name: "CentrosCustosContainer",
  
  components: {
    CentrosCustosTable,
    CentroCustosFilter
  },
  
  mixins: [
    filtrosMixin,
    buscaDadosMixin,
    exportacaoMixin
  ]
};
</script>

<style scoped>
.loading {
  height: 10vh;
}
</style>

<style scoped></style>
